import React from 'react'
import {Block, Col, Row} from 'jsxstyle'
import {XpertKnowledgeSubSectionDto, XpertKnowledgeSubSectionSource} from '../../../services/XpertKnowledgeSection/type'
import i18n from '../../../common/i18n'
import {useXpertKnowledgeAuthContext} from '../../../components/AuthContext'
import {UserRole} from '../../../services/User/type'
import {BlobType} from '../../../services/Blob/type'
import RichTextContent from '../../../components/RichTextContent'
import {useResponsiveBreakpoints} from '../../../hooks/mediaQueries'

interface XpertKnowledgeSubSectionProps {
  sectionId: number
  xpertKnowledgeSubSection: XpertKnowledgeSubSectionDto
  index: number
  subSectionCount: number
}

const XpertKnowledgeTutorialSubSection: React.FC<XpertKnowledgeSubSectionProps> = ({sectionId, xpertKnowledgeSubSection, index, subSectionCount}) => {
  const {tablet, laptop} = useResponsiveBreakpoints()
  const {user} = useXpertKnowledgeAuthContext()

  return (
    <Col
      gap="10px"
      backgroundColor="#edeeef"
      padding="24px 28px"
      borderRadius="6px"
      props={{id: `section-${sectionId}-subsection-${xpertKnowledgeSubSection.id}`}}
      transition="all 0.3s ease"
      {...(!tablet && {
        padding: '16px 20px',
        gap: '8px',
      })}
      {...(tablet &&
        !laptop && {
          padding: '20px 24px',
        })}
    >
      <Row justifyContent="space-between" alignItems="center">
        <Block
          fontWeight={500}
          lineHeight="36px"
          fontSize="24px"
          transition="all 0.3s ease"
          {...(!tablet && {
            fontSize: '18px',
            lineHeight: '26px',
          })}
          {...(tablet &&
            !laptop && {
              fontSize: '20px',
              lineHeight: '30px',
            })}
        >
          {subSectionCount > 1 ? `${index + 1}. ${xpertKnowledgeSubSection.title}` : xpertKnowledgeSubSection.title}
        </Block>

        {user?.role === UserRole.ADMIN_SIGHTCALL && xpertKnowledgeSubSection.source === XpertKnowledgeSubSectionSource.DOCUMENTATION && (
          <Block
            padding="8px 16px"
            borderRadius="6px"
            fontWeight={400}
            fontSize="13px"
            lineHeight="16px"
            color="#0E78F5"
            backgroundColor="#E5F5FF"
            marginLeft="16px"
          >
            {i18n.t('xk.tutorial.subsection.source')}
          </Block>
        )}
      </Row>

      <RichTextContent content={xpertKnowledgeSubSection.content} />
      <Row
        width="100%"
        gap="10px"
        flexWrap="wrap"
        transition="all 0.3s ease"
        {...(!tablet && {
          gap: '8px',
        })}
      >
        {xpertKnowledgeSubSection.medias?.map(
          (media) =>
            media.isShow && (
              <Block
                key={media.blob.url}
                marginTop="10px"
                marginBottom="10px"
                width="calc(30% - 2px)"
                className="ph-no-capture"
                transition="all 0.3s ease"
                {...(!tablet && {
                  width: '100%',
                  marginTop: '8px',
                  marginBottom: '8px',
                })}
                {...(tablet &&
                  !laptop && {
                    width: 'calc(50% - 5px)',
                  })}
              >
                {media.blob.type === BlobType.IMAGE && (
                  <img src={media.blob.url} alt="Sub-section media" style={{width: '100%', borderRadius: '4px'}} />
                )}
                {media.blob.type === BlobType.VIDEO && (
                  <video controls style={{width: '100%', borderRadius: '4px'}}>
                    <source src={media.blob.url} type="video/mp4" />
                  </video>
                )}
              </Block>
            )
        )}
      </Row>
    </Col>
  )
}

export default XpertKnowledgeTutorialSubSection
